import React from "react";
import { connect } from "react-redux";
import DossierActions from "../redux/DossierRedux";
import { Link } from "react-router-dom";

import Layout from "../components/Layout";
import Loading from "../components/UI/Loading/Loading";
import Button from "../components/UI/Button/Button";
import Input from "../components/UI/Input/Input";
import { updateObject, checkValidity } from "../shared/utility";

class StartDossierPage extends React.Component {
  constructor(props) {
    super(props);
    const dossier = props.dossier;

    this.state = {
      form: {
        id: {
          elementType: "input",
          elementConfig: {
            type: "text",
            placeholder: "id",
          },
          value: "",
          validation: {
            required: true,
            minLength: 5,
            maxLength: 5
          },
          valid: false,
          touched: false,
        },
      },
      formIsValid: false,
      dossier: dossier,
    };
  }

  static getDerivedStateFromProps = (nextProps, nextState) => {
    if (nextProps.dossier !== null && nextProps.dossier !== nextState.dossier) {
      nextProps.history.replace("/nouveau-dossier");
    }
    return nextProps;
  };

  submitHandler = (event) => {
    event.preventDefault();
    const formData = {};
    for (let formElementIdentifier in this.state.form) {
      formData[formElementIdentifier] = this.state.form[
        formElementIdentifier
      ].value;
    }
    if (formData.id != null) {
      this.props.getDossier(formData.id);
      this.setState({ id: formData.id });
    }
  };

  inputChangedHandler = (event, inputIdentifier) => {
    const updatedFormElement = updateObject(this.state.form[inputIdentifier], {
      value: event.target.value,
      valid: checkValidity(
        event.target.value,
        this.state.form[inputIdentifier].validation
      ),
      touched: true,
    });
    const updatedForm = updateObject(this.state.form, {
      [inputIdentifier]: updatedFormElement,
    });

    let formIsValid = true;
    for (let inputIdentifier in updatedForm) {
      formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
    }

    this.setState({ form: updatedForm, formIsValid: formIsValid });
  };

  render() {
    let errorsMessages = "";
    if (this.props.error && this.props.errorMessage !== null) {
      errorsMessages = (
        <div className="alert alert-danger" role="alert">
          {this.props.errorMessage}
        </div>
      );
    }

    const formElementsArray = [];
    for (let key in this.state.form) {
      formElementsArray.push({
        id: key,
        config: this.state.form[key],
      });
    }
    let form = (
      <form className="py-5" onSubmit={this.submitHandler} method="POST">
        <div className="form-group text-center">
          <Link to="/nouveau-dossier" className="btn btn-success">
            Nouvelle saisie
          </Link>
        </div>
        <div className="form-group text-center py-3">
          <p className="mb-0">
            <strong>OU</strong>
          </p>
        </div>
        <div className="form-inline justify-content-center pb-5">
          <div className="form-group text-center">
            {formElementsArray.map((formElement) => (
              <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                touched={formElement.config.touched}
                changed={(event) =>
                  this.inputChangedHandler(event, formElement.id)
                }
              />
            ))}{" "}
            <Button classes="btn btn-success" btnType="Submit">
              Reprise de formalité ayant cet id
              {this.props.isFetching === true ? <Loading /> : ""}
            </Button>
          </div>
        </div>
      </form>
    );

    return (
      <Layout>
        {errorsMessages}
        {form}
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    dossier: state.dossiers.dossier,
    isFetching: state.dossiers.fetching,
    error: state.dossiers.error,
    errorMessage: state.dossiers.errorMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getDossier: (id) => dispatch(DossierActions.getDossier(id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StartDossierPage);
